TS.ns('WL');

WL.scoringDimensionSelection = new Class({ 
    Extends: TS.domain.EditDomain,

    initialize: function (config) {
        var me = this;

        me.parent(config);
    },

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var dimensionList = me.getDomainProperty('dgFinancialIndicatorDimensionsData_Property');
        if (dimensionList) {
            dimensionList.on('afterAdd', me.onDimensionAdded);
            dimensionList.on('cellValueChanged', me.onCellValueChanged);
            dimensionList.on('beforeDelete', me.onDimesionIsDeleted);
            dimensionList.on('cellBeginEdit', me.onDimensionBeginEdit);

            if (!me.PeriodIsVisible())
                dimensionList.getFieldByName('DimensionPeriod1_Field').Visible(false);

            dimensionList.customiseOptions = function (options) {

                options.dataBound = function (e) {
                    var rows = e.sender.tbody.children();
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = e.sender.dataItem(row);
                        if (dataItem.HasPartnerData) 
                            row.addClass("scoringWithData");
                    }
                }
            }
        }
    },

    onDimesionIsDeleted: function (e) {
        if (e.item.EntityStatus && e.item.EntityStatus()!='Added') {
            e.preventDefault();
            window.alert(this._getOwner().DeleteDimensionError());
        }
    },

    onDimensionAdded: function (e) {
        var me = this,
            owner = me._getOwner();

        e.item.DimSource(-1);
        e.item.SourceName('Manual');
    },

    onCellValueChanged: function (e) {

        var me = this,
            owner = me._getOwner(),
            val = e.newValue;

        if (e.oldValue == e.newValue)
            return;

        if (!e.record.EntityStatus)
        {

            if ((e.fieldName == 'DimYear' || e.fieldName == 'DimMonth') && e.record.DimYear() && e.record.DimMonth()) {
                e.record.Name(e.record.DimYear() + '.' + e.record.DimMonth());
                e.record.Code(e.record.DimYear() +''+ e.record.DimMonth());
            }
        }

    },

    onDimensionBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner(),
            val = e.newValue;

        if (e.record.EntityStatus) {

            if ((e.fieldName == 'DimYear' || e.fieldName == 'DimMonth')) {
                e.preventDefault();
            }
        }

    }
});